import { observable, makeObservable } from 'mobx';

import type { LaboratoryTestResult, LaboratoryTestResultParams } from 'chaika-frontend-types/frontend-cms';
import { LaboratoryTestStatus } from 'chaika-enums';

export class LaboratoryTest {
    @observable public serviceId: string;
    @observable public params: LaboratoryTestResultParams[];
    @observable public status: LaboratoryTestStatus;

    constructor({ serviceId, status, params = [] }: LaboratoryTestResult) {
        makeObservable(this);

        this.serviceId = serviceId;
        this.status = status;
        this.params = params;
    }

    public serialize(): LaboratoryTestResult {
        return {
            serviceId: this.serviceId,
            params: this.params,
            status: this.status,
        };
    }
}
